import { Editor, TLShapeUtilConstructor, createTLStore } from '@tldraw/tldraw'
import { useEffect, useRef } from 'react'
import { shapeUtils } from '../VisualEditor'
import { getColors } from '../helpers'

/**
 * Extracts colors from a design content object.
 *
 * @returns A function that accepts a design content object and returns an
 * array of colors.
 */
export const useExtractColors = () => {
  const tlStore = useRef(createTLStore({ shapeUtils }))

  const editor = useRef(
    new Editor({
      store: tlStore.current,
      shapeUtils: shapeUtils as TLShapeUtilConstructor<any, any>[],
      tools: [],
      getContainer: () => document.createElement('div'),
    }),
  )

  useEffect(() => editor.current.dispose(), [])

  return (content: any) => {
    tlStore.current.loadSnapshot(content)

    return Array.from(getColors(editor.current).values()).map((color) => {
      if (color.type === 'linearGradient') {
        return color.stops[0].color
      }
      return color.color
    })
  }
}
